
  import { defineComponent, ref } from 'vue'
  import { mapState, mapActions } from 'vuex'
  import { TokenService } from '@/services/TokenService'
  import { UserService } from '@/services/UserService'
  import LogoCertificata from '@/assets/components/LogoCertificata.vue'

  import {
    LogoutOutlined,
    SettingOutlined,
    ToolOutlined,
    DownOutlined,
    MenuOutlined,
    HomeOutlined,
    WhatsAppOutlined,
    MailOutlined,
    CheckCircleFilled
  } from '@ant-design/icons-vue'

  export default defineComponent({
    name: 'HeaderPages',
    components: {
      LogoutOutlined,
      SettingOutlined,
      ToolOutlined,
      DownOutlined,
      MenuOutlined,
      HomeOutlined,
      WhatsAppOutlined,
      MailOutlined,
      CheckCircleFilled,
      LogoCertificata
    },
    props: {
      page: {
        type: String
      }
    },
    data: () => ({
      isDocument: ref<boolean>(false),
      isConfiguration: ref<boolean>(false),

      // Modal do suporte
      suporteModalVisible: false,
      suporteMessage: '',
      suporteSuccess: false
    }),
    async mounted () {
      if (this.page === 'document') {
        this.isDocument = true
        this.isConfiguration = false
      } else if (this.page === 'configuration') {
        this.isDocument = false
        this.isConfiguration = true
      }

      // Carrega o widget GPTMaker somente após o login (Header só existe nas telas autenticadas)
      this.loadGptMakerWidget()
    },
    computed: {
      ...mapState('sections', [
        'drawerMenu'
      ])
    },
    methods: {
      ...mapActions('sections', [
        'setDrawerMenu'
      ]),

      loadGptMakerWidget () {
        // Evita carregar o script mais de uma vez
        if (document.getElementById('gptmaker-widget-script')) return

        const script = document.createElement('script')
        script.id = 'gptmaker-widget-script'
        script.async = true
        script.src = 'https://app.gptmaker.ai/widget/3FAA2E8B33D9E3D63B74FAC5C60696FD/float.js'
        document.body.appendChild(script)
      },

      removeGptMakerWidget () {
        // Remove o script
        const script = document.getElementById('gptmaker-widget-script')
        if (script) script.remove()

        // Remove elementos injetados pelo widget
        document.querySelectorAll('.gptm-launcher, .gptm-panel, .gptm-popup, .popup-widget')
          .forEach((el) => el.remove())

        // Remove o CSS injetado
        document.querySelectorAll('style').forEach((styleEl) => {
          if (styleEl.textContent && styleEl.textContent.includes('.gptm-launcher')) {
            styleEl.remove()
          }
        })

        // Limpa variáveis globais
        try {
          delete (window as any).GPT_CHAT_IFRAME_FUNCTIONS
          delete (window as any).GPT_CHAT_IFRAME_ELEMENTS
          delete (window as any).GPT_CHAT_IFRAME_VARIABLES
        } catch (e) { /* ignore */ }
      },

      logout () {
        this.removeGptMakerWidget()
        TokenService.clear()
        this.$router.push({ name: 'authenticator' })
      },

      openSuporteWhats () {
        const phone = '5545999470298'
        const text = encodeURIComponent('Olá! Preciso de ajuda.')
        const url = `https://wa.me/${phone}?text=${text}`
        window.open(url, '_blank')
      },

      openSuporteMail () {
        this.suporteModalVisible = true
        this.suporteSuccess = false
        this.suporteMessage = ''
      },

      sendSupportMail () {
        const userDataByToken = TokenService.getUserData()
        const data = {
          userContact: userDataByToken.userEmail,
          contactMessage: this.suporteMessage
        }

        const service = UserService.getInstance()
        service.sendSupportMail(data)

        this.suporteSuccess = true

        setTimeout(() => {
          this.closeSupportModal()
        }, 5000)
      },

      closeSupportModal () {
        this.suporteModalVisible = false
        this.suporteSuccess = false
        this.suporteMessage = ''
      }
    }
  })
